import { html } from "lit";
import { SelectedState } from "../selected-state.js";
import { property } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const OfferPaymentMixin = (superClass) => {
  class OfferPaymentElement extends superClass {
    constructor() {
      super(...arguments);
      this.includePaymentElement = false;
    }
    /**
     * @ignore
     */
    renderPaymentElement() {
      if (this.includePaymentElement && this.selectedState === SelectedState.ACCEPTED) {
        return html`<payment-element .customerClientSecret=${this.customerClientSecret} .clientId=${this.clientId}></payment-element>`;
      }
    }
    async validate() {
      var _a;
      let currentErrors = [];
      const isInsuranceValid = this.selectedState != SelectedState.UNKNOWN;
      if (!isInsuranceValid) {
        currentErrors.push("selection_required");
      }
      let paymentElementValid = true;
      const paymentElement = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("payment-element");
      if (paymentElement) {
        const paymentValidationRes = await paymentElement.validate();
        currentErrors = [...currentErrors, ...paymentValidationRes.errors];
        paymentElementValid = paymentValidationRes.isValid;
      }
      this.errors = currentErrors;
      return {
        isValid: isInsuranceValid && paymentElementValid,
        errors: currentErrors
      };
    }
    async getPaymentToken(cardHolderName, billingZipCode, emailAddress) {
      var _a;
      if (this.includePaymentElement) {
        const paymentElement = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("payment-element");
        const paymentData = {
          name: cardHolderName,
          address_postal_code: billingZipCode
        };
        if (emailAddress) {
          paymentData["email"] = emailAddress;
        }
        if (paymentElement) return await paymentElement.tokenize(paymentData);
      }
    }
  }
  __decorateClass([
    property({ type: Boolean, attribute: "include-payment-element" })
  ], OfferPaymentElement.prototype, "includePaymentElement");
  return OfferPaymentElement;
};
export {
  OfferPaymentMixin
};
